import GaiaMYHProductDetailonPopup from "@gaiaProfessionals/Components/MeetYourHerbsDetails/GaiaMYHProductDetailonPopup";
import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    qAimage1Url = "qAimage1Url",
    qAimage2Url = "qAimage2Url",
    qAaltText1 = "qAaltText1",
    qAaltText2 = "qAaltText2",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.qAimage1Url]: string;
        [fields.qAimage2Url]: string;
        [fields.qAaltText1]: string;
        [fields.qAaltText2]: string;
    };
}

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    const product = state.customMeetYourHerbsReducer?.product;
    return {
        product,
        purityTest: state.customMeetYourHerbsReducer?.product?.cofc?.purity_tests,
    };
};

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

export interface GaiaMYHCompleteTestingStyles {
    viewButton?: ButtonProps;
    certificateModal?: ModalPresentationProps;
    modalWarpper?: InjectableCss;
    subTitleWrapper?: InjectableCss;
    subtitle?: TypographyProps;
    printResult?: LinkPresentationProps;
}

export const partNumberStyles: GaiaMYHCompleteTestingStyles = {
    viewButton: {
        variant: "secondary",
        css: css`
            border-radius: 10px;
            color: ${getColor("common.accent")};
            padding: 0 20px;
            &:focus {
                outline: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            padding: 0 10px;
                        `,
                        css`
                            width: 100%;
                            padding: 0 10px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    certificateModal: {
        size: 900,
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            headlineTypography: css`
                font-size: 22px;
                color: ${getColor("primary")};
                margin-bottom: 0;
            `,
            modalContent: css`
                padding: 20px 20px;
            `,
        },
    },
    subTitleWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-bottom: 13px;
        `,
    },
    subtitle: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    printResult: {
        css: css`
            font-weight: 600;
        `,
    },
    modalWarpper: {
        css: css``,
    },
};

const styles = partNumberStyles;

const GaiaMYHCompleteTesting: React.FC<Props> = ({ product, fields }) => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const onChangeModelHandler = () => {
        setModalIsOpen(true);
    };
    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    return (
        <>
            <Button {...styles.viewButton} onClick={onChangeModelHandler}>
                {translate("View Complete Testing Certificate")}
            </Button>
            <Modal
                isOpen={modalIsOpen}
                {...styles.certificateModal}
                as="h2"
                headline={translate("Certificate of Compliance")}
                handleClose={handleCloseModal}
            >
                <StyledWrapper {...styles.modalWarpper}>
                    <GaiaMYHProductDetailonPopup product={product} feilds={fields} />
                </StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GaiaMYHCompleteTesting),
    definition: {
        displayName: "MYH Complete Testing Certificate",
        group: "MYH Product Details" as WidgetGroup,
        fieldDefinitions: [
            {
                name: fields.qAimage1Url,
                fieldType: "General",
                displayName: "QA Approval 1",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: fields.qAaltText1,
                fieldType: "General",
                displayName: "approval 1 alttext",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.qAimage2Url,
                fieldType: "General",
                displayName: "QA Approval 2",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: fields.qAaltText2,
                fieldType: "General",
                displayName: "approval 2 alttext",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
